import { ApolloError } from '@apollo/client';
import { useCallback } from 'react';
import {
  ListRuleAssessmentsQuery,
  useListRuleAssessmentsLazyQuery,
} from '../types';

export type UseListRuleAssessmentsHook = {
  data?: ListRuleAssessmentsQuery;
  loading: boolean;
  error?: ApolloError;
  search: (resourceId: string) => void;
};

export function useListRuleAssessmentsHook(): UseListRuleAssessmentsHook {
  const [fetch, { data, loading, error }] = useListRuleAssessmentsLazyQuery();

  const search = useCallback(
    (resourceId: string): void => {
      if (resourceId) {
        fetch({
          variables: { listRuleAssessmentsInput: { resourceId } },
          fetchPolicy: 'network-only',
        });
      }
    },
    [fetch],
  );

  return {
    data,
    loading,
    error,
    search,
  };
}
